import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {Button, message} from 'antd';
import {HttpStatusCode} from 'axios';
import CustomModal from '@component/CustomModal';
import CustomValidFormInput from '@component/form/CustomValidFormInput';
import {callFindUserId} from '@api/UserManagementApi';
import {UserFind} from '@interface/master/UserManagementIF';

interface FindIdPopupProps {
    onClose?: () => void;
}

/**
 * 아이디 찾기 — 이름 + 휴대폰번호로 사용자 ID 조회.
 * 로그인 화면의 "아이디찾기" 모달 내용. (운영 jar 번들에서 복원)
 */
const FindIdPopup = (props: FindIdPopupProps) => {
    const {control, register, reset, handleSubmit} = useForm<UserFind>({mode: 'onSubmit'});
    const [info, setInfo] = useState<UserFind>({userName: '', hpNo: '', userId: ''});
    const [resultOpen, setResultOpen] = useState<boolean>(false);

    const handleReset = () => {
        setInfo({userId: '', userName: '', hpNo: ''});
        reset();
    };

    const handleFind = async (value: UserFind) => {
        try {
            const result = await callFindUserId(value);
            if (result.code === HttpStatusCode.Ok && result.item) {
                setInfo({userId: result.item.userId, userName: '', hpNo: ''});
                setResultOpen(true);
            } else {
                message.warning('해당 정보로 등록된 아이디가 없습니다.');
                handleReset();
            }
        } catch (e) {
            message.error('관리자에게 문의바랍니다.');
            console.error(e);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(handleFind)}>
                <span className="tit">이름</span>
                <div>
                    <div className="box-inp">
                        <CustomValidFormInput
                            title={'이름'}
                            control={control}
                            required={true}
                            onChangeValue={(v) => setInfo({...info, userName: v})}
                            {...register('userName', {required: '이름을 입력하세요.'})}
                        />
                    </div>
                </div>
                <span className="tit">휴대폰번호</span>
                <div>
                    <div className="box-inp">
                        <CustomValidFormInput
                            title={'휴대폰번호'}
                            control={control}
                            required={true}
                            onChangeValue={(v) => setInfo({...info, hpNo: v})}
                            {...register('hpNo', {required: '휴대폰번호를 입력하세요.'})}
                        />
                    </div>
                </div>
                <Button type="primary" style={{marginTop: 10}} onClick={handleSubmit(handleFind)}>아이디 찾기</Button>
                <Button type="primary" style={{marginTop: 10}} onClick={props.onClose}>닫기</Button>
            </form>

            {info.userId && (
                <CustomModal open={resultOpen}
                             footer={null}
                             onCancel={() => {
                                 handleReset();
                                 setResultOpen(false);
                                 props.onClose && props.onClose();
                             }}>
                    <p style={{fontSize: 20}}>회원님의 아이디는 <strong>{info.userId}</strong> 입니다.</p>
                    <Button type="primary" style={{marginTop: 10}} onClick={props.onClose}>닫기</Button>
                </CustomModal>
            )}
        </div>
    );
};

export default FindIdPopup;
